// extracted by mini-css-extract-plugin
export default {"disabledIcon":"LeftMenu_disabledIcon__cH3rt","enabledIcon":"LeftMenu_enabledIcon__2pW4t"};